var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import wait from 'root/src/shared/util/wait';
import { GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { GiveawayWonModal } from 'root/src/client/web/giveaway/features/GiveawaySection/GiveawayWonModal';
import toast from 'react-hot-toast';
import { useEffect } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useUserId } from 'root/src/client/v2/auth/hooks/useUserId';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { GiveawayEvent } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useSetupGiveawayListeners';
export const useGiveawayLifecycle = () => {
    const modal = useModal();
    const { userId } = useUserId();
    const { fetchGiveaways } = useCreatorDataApi();
    const handleGiveawayFinished = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        // wait until vouchers are created
        yield wait(1000);
        const result = yield fetchGiveaways();
        const resolvedGiveaway = (_b = (_a = result.body) === null || _a === void 0 ? void 0 : _a.giveaways) === null || _b === void 0 ? void 0 : _b.find(g => g.status === GiveawayStatus.Resolved);
        if (!resolvedGiveaway) {
            return;
        }
        const isWinner = (_d = (_c = resolvedGiveaway.vouchers) === null || _c === void 0 ? void 0 : _c.some) === null || _d === void 0 ? void 0 : _d.call(_c, voucher => voucher.owner.id === userId);
        const isParticipant = resolvedGiveaway.actions.some(a => a.entries.some(e => e.participantId === userId));
        const isGiveawayOwner = resolvedGiveaway.ownerId === userId;
        if (isGiveawayOwner || !isParticipant) {
            return;
        }
        if (isWinner) {
            modal.show(<GiveawayWonModal />);
            return;
        }
        toast.success('Giveaway has finished. You were not lucky this time, better luck next time! 🫡', {
            duration: 30000,
        });
    });
    useEffect(() => {
        window.addEventListener(GiveawayEvent.Ended, handleGiveawayFinished);
        return () => {
            window.removeEventListener(GiveawayEvent.Ended, handleGiveawayFinished);
        };
    }, []);
};
